import { useEffect, useState } from 'react';
import * as TrackingService from 'common/services/tracking.service';
import { TRACKING } from 'common/constants/constants';

const useIssuesDisplay = ({ selectedCategory }) => {
  const [shouldDisplayIssues, setShouldDisplayIssues] = useState(false);

  const toggleIssuesDisplay = () => {
    setShouldDisplayIssues(prev => !prev);
    if (!shouldDisplayIssues) {
      TrackingService.logEvent(TRACKING.EVENTS.CLICK, {
        page: TRACKING.PAGES.INVESTMENT_PROFILE,
        click_type: TRACKING.CLICK.INVESTMENT_PROFILE.VIEW_ISSUES,
        category: selectedCategory?.key
      });
    }
  };

  useEffect(() => {
    setShouldDisplayIssues(false);
  }, [selectedCategory]);

  return {
    shouldDisplayIssues,
    toggleIssuesDisplay
  };
};

export default useIssuesDisplay;
